import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-enterprise";
import moment from "moment";

export const useTableData = () => {
	const columns: ColDef[] = [
		{
			field: "Start",
			headerName: "Date",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.Start}`, "MM/dd") || "",
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			sortable: true,
		},
		{
			field: "AssetName",
			headerName: "Line",
			valueGetter: (params) => params.data?.AssetName || "",
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			sortable: true,
		},
		{
			field: "Start",
			headerName: "Start",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.Start}`, "HH:mm:ss") || "",
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			sortable: true,
		},
		{
			field: "End",
			headerName: "End",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.End}`, "HH:mm:ss") || "",
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			sortable: true,
		},
		{
			field: "Duration",
			headerName: "Duration",
			valueFormatter: (params) => {
				if (params.value) {
					const duration = moment.duration(params.value, "seconds");
					const minutes = Math.floor(duration.asMinutes());
					const seconds = duration.seconds();

					const formattedMinutes = String(minutes).padStart(2, "0");
					const formattedSeconds = String(seconds).padStart(2, "0");

					return `${formattedMinutes}m ${formattedSeconds}s`;
				}
				return "";
			},
			minWidth: 80,
			maxWidth: 120,
			flex: 1,
			sortable: true,
		},
		{
			field: "DelayCodePath",
			headerName: "Code",
			flex: 2,
			cellStyle: {
				justifyContent: "flex-start",
				textAlign: "left",
			},
			wrapText: true,
			minWidth: 260,
		},
		{
			field: "DelayCategoryName",
			headerName: "Category",
			maxWidth: 150,
			minWidth: 140,
			flex: 1,
		},
		{
			field: "Comments",
			headerName: "Comments",
			minWidth: 120,
			flex: 3,
			sortable: true,
			cellStyle: {
				justifyContent: "flex-start",
			},
			wrapText: true,
			autoHeight: true,
		},
		{
			field: "JustifiedByUser",
			headerName: "User",
			maxWidth: 100,
			minWidth: 100,
			editable: false,
			flex: 1,
			sortable: true,
		},
		{
			field: "JustifiedDateTime",
			headerName: "Justification",
			valueGetter: (params) =>
				dxtToLocalServerTime(`${params.data?.JustifiedDateTime}`, "HH:mm:ss") ||
				"",
			maxWidth: 150,
			minWidth: 100,
			flex: 1,
			sortable: true,
		},
	];

	return { columns };
};
